import React, { useState } from "react"

import { CaretIcon } from "components/page-components/Icons/small"
import { Link } from "gatsby"

export const ExpandableCategoryTablecell = ({
  RefIDStringBI,
  TitelOnline,
  top_three_categories,
  main_pod,
}) => {
  const [categories_open, set_categories_open] = useState(false)
  const toggle_categories = () => set_categories_open(!categories_open)
  return (
    <td>
      <Link
        to={`/ausschreibungsdienste/ausschreibungen/${RefIDStringBI}`}
        className="link is-semi-shy"
      >
        {TitelOnline}
      </Link>
      <div
        className={`is-clickable has-text-mitternachtsblau has-text-weight-bold mb-1 help`}
        aria-label="close image modal"
        onClick={toggle_categories}
        onKeyUp={() => {}} // this is necessary to keep the linter quiet :(
        role="button"
        tabIndex="0"
      >
        <CaretIcon
          {...{
            size: 0.7,
            rotation: categories_open ? "down" : "right",
          }}
        />
        <span className="title is-8 has-text-mitternachtsblau ml-1">
          Leistungen anzeigen
        </span>
      </div>
      <ul
        className="ml-1 help"
        style={{
          paddingLeft: 9,
          transition: "all .5s ease",
          maxHeight: categories_open ? "1500px" : "0px",
          opacity: categories_open ? "1" : "0",
          visibility: categories_open ? "visible" : "hidden",
        }}
      >
        {top_three_categories?.map(({ category_id, short_name }, i) => {
          return (
            <li className={`my-1 ml-1`} key={`category_cell-${i}`}>
              <Link
                to={`/ausschreibungsdienste/ausschreibungen/${RefIDStringBI}?category_string=${category_id}`}
                className="link is-semi-shy"
              >
                {short_name} in {main_pod}
              </Link>
            </li>
          )
        })}
      </ul>
    </td>
  )
}
